import { AdminAPI } from 'api/build/adminAPI';

export * from 'api/build/adminAPI';
// eslint-disable-next-line
export default new AdminAPI();
